import { makeStyles } from '@material-ui/styles'
import imberaLogo from '../../resources/images/imberalogo.png'


/**
 * Sidebar styles
 */
export const useSideBarStyles = makeStyles((theme) => ({
    root: {
        marginRight: '5px',
        width: '45px',
        height: "100%",
        // Scroll the sidebar's contents instead of growing the chrome when items overflow.
        // The page itself stays the same height as before — only the icon list scrolls.
        overflowY: 'auto',
        overflowX: 'hidden',
        // Hide the scrollbar gutter for a cleaner look; Firefox + WebKit covered.
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
            width: '4px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: '2px'
        }
    },
    header: {
        height: theme.mixins.toolbar.minHeight,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundImage: `url(${imberaLogo})`
    },
    content: {
        backgroundColor: theme.palette.common.gray,
        padding: '10px'
    },
    iconButton: {
        marginLeft: '2px',
        width: theme.spacing(5),
        height: theme.spacing(5)
    },
    activeIcon: {
        backgroundColor: theme.palette.primary.main
    }
}))
 